import Landing from "components/organisms/Landing/Landing";

export default function HomeTemplate() {
  return <Landing />;
}
